import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import { Row, Col, FormGroup, InputGroup, FormControl, Collapse, Button as SearchButton } from 'react-bootstrap';
import Transition from 'react-transition-group/Transition';
import LoadingMessage from 'src/legacy/components/LoadingMessage';
import { ToolBar, ToolBarGroup } from 'src/legacy/components/ToolBar/ToolBar.jsx';
import { ToolBarButtonItem } from 'src/legacy/components/ToolBar/ToolBarButtonItem.jsx';
import InputField from 'src/legacy/components/InputField';
import { toast } from 'react-toastify';
import styles from './userRoleDetailView.module.scss';
import BackButton from 'src/legacy/components/BackButton';
import isEqual from 'is-equal';
import UserRoleListContainer from './UserRoleListContainer';
import _ from 'lodash';
import { localizedStrings } from 'src/localization/index.jsx';
import userRoleService from "src/services/userRoles.service.js";
import Toast from 'src/components/toast';
import Button from 'src/components/button';
import DeleteUserRoleDialog from "./DeleteUserRoleDialog.jsx"

class UserRoleDetailView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired
  }
  constructor(props) {
    super(props);

    this.state = {
      query: "",
      name: "",
      errors: {},
      creating: false,
      deleting: false,
      permissions: {},
      showDeleteDialog: false
    }
    
    this._handleSaveClick = this._handleSaveClick.bind(this);
    this._handleToggleOption = this._handleToggleOption.bind(this);
    this._handleCreateUserRoleClick = this._handleCreateUserRoleClick.bind(this);
    this._handleConfirmClicked = this._handleConfirmClicked.bind(this);
    this._handleHeadingToggle = this._handleHeadingToggle.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonLoading = this.localizedCommons.loading;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedUserManagement = this.localizedSettings.account.user_management;
    this.localizedManageRoles = this.localizedUserManagement.manage_roles;
    this.localizedAccess = localizedStrings.constants.userAccesses;
  }

  _handleToggleOption(e, userAccess, permission) {
    if(this.isSystemDefined()) {
      return;
    }
    this.setState({
      permissions: {
        ...this.state.permissions,
        [userAccess.key]: {
          ...this.state.permissions[userAccess.key],
          [permission.key]: !(_.get(this.state, `permissions[${userAccess.key}][${permission.key}]`))
        }
      }
    })
  }

  _handleChange(field, e) {
    this.setState({
      [field]: e.target.value,
      errors: {}
    });
  }

  componentDidMount() {
    this.props.hideSettingsSideMenu();
    this.props.fetchUserRolesForAccount();

    if (this.props.params.id) {
      if (this.props.params.id !== 'new') {
        this.props.fetchUserRole(this.props.params.id);
      } else {
        this.setState({
          creating: true,
          name: this.localizedCommons.untitled,
          permissions: {}
        })
      }
    }

    if (this.props.userRole) {
      this.setState({
        name: this.props.userRole.name,
        permissions: this.props.userRole
      })
    }
    if(this.props.userRoles && this.props.userRoles.length > 0) {
      this.setState({
        name: this.props.userRoles[0].name,
      }, () => {
        var first = this.props.userRoles[0];
        this.props.navigate(`/settings/user-roles/${first.id}`);
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.params.id, nextProps.params.id)) {
      if (this.localizedAccess != null) {
        this.localizedAccess.userAccesses.forEach(userAccess => {
          this.setState({
            [userAccess.key]: false
          })
        })
      }
      
      if (nextProps.params.id != "new") {
        this.props.fetchUserRole(nextProps.params.id);
        this.setState({
          creating: false
        })
      } else {
        this.setState({
          creating: true,
          name: this.localizedCommons.untitled,
          permissions: {}
        })
      }
    }

    if (!isEqual(this.props.userRole, nextProps.userRole) && nextProps.userRole && nextProps.params.id != "new") {
      this.setState({
        name: nextProps.userRole.name,
        permissions: nextProps.userRole
      })
    }

    if(!this.props.userRoles && nextProps.userRoles && nextProps.userRoles.length > 0) {
      var first = nextProps.userRoles[0];
      this.props.navigate(`/settings/user-roles/${first.id}`);
    }
  }

  _handleCreateUserRoleClick() {
    this.props.navigate("/settings/user-roles/new");
    this.setState({
      creating: true,
      name: "Untitled",
      permissions: {}
    })
  }

  _handleCancelCreate() {
    this.setState({
      creating: false,
      errors: {}
    })

    this.props.navigate("/settings/user-roles");
  }

  _handleSaveClick() {
    let errors = this._validateForm();

    if (Object.keys(errors).length > 0) {
      this.setState({
        errors: errors
      })

      return;
    }

    var request = {
      ...this.state.permissions,
      name: this.state.name
    }

    if(this.props.params.id === 'new') {
      this.props.createUserRole(request).then((response) => {
        this.props.navigate(`/settings/user-roles/${response.payload.id}`);
        this.setState({
          creating: false
        })

        toast(
          <Toast.Sucess
            message={localizedStrings.formatString(this.localizedManageRoles.toast.created, {name: this.state.name})}
          />, {
          autoClose: 3000,
        })
      });
    } else {
      this.props.updateUserRole(this.props.params.id, request).then(() => {
        toast(
          <Toast.Sucess
            message={localizedStrings.formatString(this.localizedManageRoles.toast.updated, {name: this.state.name})}
          />, {
          autoClose: 3000,
        })
      });
    }
  }

  _handleConfirmClicked() {
    this.props.deleteUserRole(this.props.userRole.id).then((response) => {
      if(this.props.userRoles.length > 0) {
        this.props.navigate(`/settings/user-roles/${this.props.userRoles[0].id}`);
        this.setState({ showDeleteDialog: false });
      } 
    })
  }

  _handleDeleteClicked() {
    this.setState({ showDeleteDialog: true });
  }

  _handleCancelClicked() {
    this.setState({ showDeleteDialog: false });
  }

  
  _validateForm() {
    var errors = {};
    if (!this.state.name || this.state.name.trim() == '') {
      errors['name'] = this.localizedManageRoles.error_message;
    }

    return errors;
  }

  isSystemDefined() {
    return !this.state.creating && _.get(this.props.userRole, 'systemDefined', false);
  }

  render() {
    return (
      <Row className={cx(styles.content)}>
        <Col md={4} className={cx(styles.listView)}>
          <div className={styles.listViewHeader}>
            <BackButton
              className={styles.back}
              title={this.localizedCommonActions.back}
              onClick={() => {
              // browserHistory.replace(`/settings/user-management/user`);
              this.props.navigate(`/settings/user-management/user`);
              this.props.showSettingsSideMenu();
              }}>
            </BackButton>

            <h1 className={styles.heading}> {this.localizedManageRoles.title}</h1>

            <div className={styles.createUserRole}>
            <div className={styles.button} onClick={this._handleCreateUserRoleClick}>
              <i className="paperflite-add" aria-hidden="true" /> {this.localizedManageRoles.create_role}
              </div>
            </div>
          </div>

          <div className={styles.listScrollContainer}>
            <UserRoleListContainer store={this.context.store}
              query={this.state.query}
              creating={this.state.creating}
              selectedId={this.props.params.id}
              location={this.props.location} />
          </div>
        </Col>
        <Col md={8} className={cx(styles.column, styles.detailsView)}>
          {this._renderDetailsView()}
        </Col>
        { this.state.showDeleteDialog && 
          <DeleteUserRoleDialog 
            name={this.state.name}
            onConfirm={this._handleConfirmClicked.bind(this)}
            onCancel={this._handleCancelClicked.bind(this)}
            show={this.state.showDeleteDialog} />
        }
      </Row>
    )
  }

  _renderDetailsView() {

    if (this.props.loading && !this.props.userRole) {
      return (
        <LoadingMessage
          className={styles.loadingMessage}
          message={`${this.localizedCommonLoading.loading}...`}
          visible={true}
        />
      )
    }

    return (
      <div className={cx(styles.detailsContainer, { [styles.fade]: this.state.addUsersView })}>
        <div className={styles.inner} ref={(element) => {
          this.scrollContainer = element;
        }}>
          <ToolBar className={cx(styles.toolbar, { [styles.trial]: this.props.trial })}>
            <ToolBarGroup direction="left">
              {!this.state.creating &&
                <div className={styles.editRoleHeading}>
                  {this.localizedManageRoles.edit_role}
                </div>}
            </ToolBarGroup> 
            <ToolBarGroup direction="right">
              {!this.state.creating && !this.isSystemDefined() && 
                <ToolBarButtonItem className={cx(styles.action)} disabled={this.props.deleting} width="auto" height="auto" onClick={this._handleDeleteClicked.bind(this)}>
                  <span className="fa fa-trash-o" /> {this.props.deleting ? `${this.localizedCommonActions.deleting}...` : this.localizedCommonActions.delete}
                </ToolBarButtonItem>}
            </ToolBarGroup>
          </ToolBar>

          <Row className={styles.userRoleDetails}>
            <InputField
              className={styles.inputField}
              title={`${this.localizedManageRoles.role_name}:`}
              placeholder=""
              value={this.state.name}
              type="text"
              focus={true}
              reference="focusOn"
              disabled={this.isSystemDefined()}
              onChange={this._handleChange.bind(this, 'name')}
            />

            <p className={styles.permissionHeading}>{this.localizedManageRoles.permissions.title}</p>
            {this._renderAccess(this.localizedAccess)}

            {(!this.isSystemDefined() || this.state.creating) &&
              <Transition
                in={true}
                timeout={0}>
                {
                  (state) => {
                    return (
                      <div className={cx(styles.actions, styles[state])}>
                        <Button
                          text={this._renderButtonText()}
                          disabled={this.props.updating || this.props.creating}
                          variant='primary'
                          onClick={this._handleSaveClick}
                          icon='paperflite-tick'
                        />
                        <Button
                          text={this.localizedCommonActions.cancel}
                          variant='secondary'
                        />
                      </div>
                    );
                  }
                }
              </Transition>
            }

          </Row>
        </div>
      </div>
    )
  }

  _renderButtonText() {
    if (this.state.creating) {
      return this.props.creating ? `${this.localizedCommonActions.creating}...` : this.localizedCommonActions.create;
    } else {
      return this.props.updating ? `${this.localizedCommonActions.saving}...` : this.localizedCommonActions.save;
    }
  }

  _handleHeadingToggle(key){
    this.setState({
      [key]: !this.state[key]
    })
  }

  handleModuleAccess(userAccess) {
    const key = userAccess.key;

    switch(key){
      case 'hub':
        return userRoleService.canAccessHub();
      case 'collection':
        return userRoleService.canAccessCollection();
      case 'conversation':
        return userRoleService.canShare();
      case 'dealRoom':
        return userRoleService.canAccessDealRoom();
      case 'engage':
        return userRoleService.canAccessEngage();
      case 'contact':
        return userRoleService.canShare();
      case 'report':
        return userRoleService.canAccessReport();
      case 'share':
        return userRoleService.canShare();
      default :
        return true;
    }
  }

  handleSubModuleAccess(userAccess, permission) {
    const module = userAccess.key;
    if (module === 'settingsManagement') {
      const subModule = permission.key;

      switch (subModule) {
        case 'contentSources':
          return userRoleService.canAccessHub();

        case 'integrations':
        case 'emailTemplates':
        case 'ndaTemplates':
        case 'privacyPolicyControl':
          return userRoleService.canShare();

      }
    }

    return true;

  }

  _renderAccess(accesses) {

    let billingEnabled = _.get(this.props.account, "item.billingEnabled", false);

    if (!billingEnabled) {
      accesses.userAccesses = accesses.userAccesses.filter(access => access.key !== 'billing');
    }

    let userAccesses = accesses.userAccesses.map((userAccess, index) => {
      if (this.handleModuleAccess(userAccess)) {

        var header = (
          <span className={styles.accessHeading} key={userAccess.key} onClick={() => this._handleHeadingToggle(userAccess.key)}><i className={cx({ ["paperflite-add"]: !this.state[userAccess.key] }, { ["paperflite-minus"]: this.state[userAccess.key] })} aria-hidden="true" /> {userAccess.name} </span>
        );

        var permissions = userAccess.permissions;
        
        return (
          <div className={styles.container}>
          <div className={styles.header}>{header}
          </div>
          <Collapse
            // header={header}
            // eventKey={userAccess.key}
            // key={userAccess.key}
            // collapsible={true}
            in={this.state[userAccess.key]}
            className={styles.userRolesAccordion}>
            <div>
            {permissions.map((permission, index) => {
              if (this.handleSubModuleAccess(userAccess, permission)) {
              var access = _.get(this.state, `permissions[${userAccess.key}][${permission.key}]`) || false;
              return (
                <div className={styles.permissions} onClick={() => this._handleToggleOption(this, userAccess, permission)}>
                  
                  {this.state.permissions != [] &&
                    <i className={cx({['paperflite-radio-button-unselected']: !access }, { ['paperflite-tick-selected']: access })} aria-hidden="true"></i>
                    
                  }
                  <span className={styles.permissionName}>{permission.name}</span>
                  <p className={styles.permissionDescription}>{permission.description}</p>
                </div>
              )
                }

            })}
            </div>
          </Collapse>
          </div>
        )
      }
    });
    return userAccesses;
  }

}

export default UserRoleDetailView;